import { createAsyncThunk } from '@reduxjs/toolkit';

import { _apiPathManagerConfig } from 'Shared/ApiPaths/ApiPathManagerSetup';

import { IPrintElhaghiyehShakhsSalesQuery } from '../SakhsSalesBimehNameh/Queries/IPrintElhaghiyehShakhsSalesQuery';
import { KhodroHttpGetService } from '../Services/KhodroHttpService';

const printElhaghiyehShakhsSales = createAsyncThunk(
  'PrintElhaghiyehShakhsSales/printElhaghiyehShakhsSales',
  async (query: IPrintElhaghiyehShakhsSalesQuery) => {
    return await KhodroHttpGetService({
      url: `${_apiPathManagerConfig?.Khodro.BimehNamehHayeShakhsSales.PrintElhaghiyehShakhsSales}`,
      params: query,
      responseType: 'blob',
      isFile: true,
    });
  }
);

export default printElhaghiyehShakhsSales;
